module.exports = __webpack_public_path__ + "img/modal_bg.b2305e38.jpg";